import React from "react";
import { Phone } from "lucide-react";
import { useLocation } from "react-router-dom";
import { Dialer } from "@/components/Dialer";

export const MobileDialerFab = () => {
  const { pathname } = useLocation();
  // Show the floating call button only on the Appels tab.
  if (pathname !== "/appels") return null;

  return (
    <div className="md:hidden fixed right-4 bottom-safe z-40">
      <Dialer
        trigger={
          <button
            data-testid="mobile-dialer-fab"
            aria-label="Appeler"
            className="h-14 w-14 rounded-full bg-emerald-600 text-white shadow-lg shadow-emerald-600/30 flex items-center justify-center active:bg-emerald-700 transition-colors"
          >
            <Phone className="h-6 w-6" strokeWidth={2.4} />
          </button>
        }
      />
    </div>
  );
};
